import SjQuestionTooltip from './src/SjQuestionTooltip.vue'

export default SjQuestionTooltip



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-tooltip/index.js